import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { candidateEndpoints } from '@/modules/candidates/constants';
import type { CandidateJobApi } from '@/modules/candidates/types';

import { candidateJobQueryKeys } from './queryKeys';

type CandidatePathParams = {
  jobId: string;
  candidateId: string;
};

export const useCandidateJobQuery = (
  { jobId, candidateId }: CandidatePathParams,
  options?: Omit<
    UseQueryOptions<CandidateJobApi | undefined, unknown>,
    'queryKey' | 'queryFn'
  >,
) => {
  return useQuery({
    queryKey: candidateJobQueryKeys.detail(jobId, candidateId),
    queryFn: async () => {
      const { data } = await fetchClient.GET(candidateEndpoints.candidateJob, {
        params: {
          path: {
            jobId,
            candidateId,
          },
        },
      });
      return data;
    },
    ...options,
  });
};
